// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "a475b6c59b3c68cbd03aecc96e91de7863f40d8e/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};